import type { AxiosResponse } from "axios"

import { axiosClient } from "$/http"

import { EAssistantParticipantsQueryUrl as EUrl } from "./assistant.participants.api.config"
import type { IAssistanceParticipantDto } from "./assistant.participants.api.types"

export default {
    async participants(): Promise<IAssistanceParticipantDto[]> {
        const { data }: AxiosResponse<IAssistanceParticipantDto[]> = await axiosClient.get(EUrl.Participants())

        return data
    }
}
